import { ethers } from 'ethers'
import abi from './abi.json'

const addr = process.env.VUE_APP_WHEELZ_CONTRACT_ADDRESS
export const apiurl = 'https://fantomwheelz.com'
export const mintStart = process.env.VUE_APP_WHEELZ_START
export const mintPrice = process.env.VUE_APP_MINT_PRICE

const targetNetwork = {
  id: process.env.VUE_APP_WHEELZ_NETWORK_ID,
  name: process.env.VUE_APP_WHEELZ_NETWORK_NAME,
  explorer: process.env.VUE_APP_WHEELZ_NETWORK_EXPLORER
}
const getContract = () => {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  let contract = new ethers.Contract(addr, abi, signer)
  return contract
}

const connectWallet = async () => {
  if (typeof window.ethereum !== 'undefined') {
    const ret = await window.ethereum.request({ method: 'eth_requestAccounts' })
    console.log(ret)
    return true
  }
  return false
}

const metamaskSelectedAddress = () => {
  const { ethereum } = window
  if (ethereum == null) {
    return null
  }
  return ethereum.selectedAddress
}

const isMetaMaskConnected = async () => {
  const { ethereum } = window
  if (ethereum != null) {
    const ret = await ethereum.request({ method: 'eth_accounts' })
    return (ret != null && ret.length > 0)
  }
  return false
}
const showStartAndEnd = (address) => {
  if (address == null) {
    return ''
  }
  if (!isMetaMaskInstalled()) {
    return 'Metamask not connected'
  }
  return address.substr(0, 6) + '...' + address.substr(address.length - 5)
}
const isMetaMaskInstalled = () => {
  // Have to check the ethereum binding on the window object to see if it's installed
  const { ethereum } = window
  return (ethereum && ethereum.isMetaMask)
}

export {
  connectWallet,
  isMetaMaskInstalled,
  isMetaMaskConnected,
  metamaskSelectedAddress,
  showStartAndEnd,
  getContract,
  targetNetwork
}



// WEBPACK FOOTER //
// ./src/walletHelpers.js